import React from 'react';
import PropTypes from 'prop-types';
import SortIcon from '-!svg-react-loader!./assets/sort.svg?name=SortIcon';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Row, Col } from 'reactstrap';
import { Button } from 'antd';
import reducer from './reducer';
import saga from './saga';
import { removeAllOptions, showAllTags, orderBy } from './actions';
import {
  makeSelectFiltersOption,
  makeSelectSort,
  makeSelectSelectedSort,
} from './selectors';

import { resetParams, downloadOffers } from '../CatalogSearch/actions';
import { makeSelectLabels, makeSelectParam } from '../CatalogSearch/selectors';

import Tags from './tags';

import './styles.scss';
import {
  SECTION_DESCRIPTION,
  SECTION_TITLE,
  SECTION_SINGLE_TITLE,
  DOWNLOAD_LIST,
} from './constants';

class HorizontalFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onCancelClick = () => {
    this.props.clearFilters();
    this.props.clearParams();
    this.props.showTags();
  };

  onOrderChange = e => {
    this.props.orderBy(e.target.value);
  };

  handleDownloadList = () => {
    this.props.downloadOffers();
  }

  render() {
    const {
      results,
      sort,
      selectedSort,
      selectedTags,
      activeFilters,
      params,
      id,
      label
    } = this.props;
    const selected = [...selectedTags, ...activeFilters];

    return (
      <div id="HorizontalFilter">
        <div className="element-wrapper">
          <div className="element-actions">
            <div className="form-inline justify-content-sm-end">
              <span className="sort-label">
                <SortIcon /> {SECTION_DESCRIPTION}
              </span>
              <label htmlFor={id} className="mb-0 sr-only sr-only-focusable">
                {label}
              </label>
              <select
                value={selectedSort}
                className="form-control form-control-sm form-control-faded"
                onChange={this.onOrderChange}
                id={id}
              >
                {sort.map((item, key) => (
                  <option value={item.value} key={key}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
            <h1 className="element-header text-medium">
              {`${results} ${results === 1 ? SECTION_SINGLE_TITLE : SECTION_TITLE}`}

            <Button
              className="ml-3"
              icon="download"
              size="small"
              type="link"
              onClick={this.handleDownloadList}
            >
              {DOWNLOAD_LIST}
            </Button>
            </h1>

          {selected.length > 0 && (
            <Row>
              <Col md={12} sm={12}>
                <Tags tags={selected} active params={params} />
                <div className="clear" onClick={this.onCancelClick}>
                  Rimuovi i filtri
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

HorizontalFilter.defaultProps = {};
HorizontalFilter.propTypes = {
  results: PropTypes.number.isRequired,
};

const mapStateToProps = createStructuredSelector({
  selectedTags: makeSelectFiltersOption(),
  activeFilters: makeSelectLabels(),
  sort: makeSelectSort(),
  selectedSort: makeSelectSelectedSort(),
  params: makeSelectParam(),
});

export function mapDispatchToProps(dispatch) {
  return {
    clearFilters: () => dispatch(removeAllOptions()),
    clearParams: () => dispatch(resetParams()),
    showTags: () => dispatch(showAllTags()),
    orderBy: value => dispatch(orderBy(value)),
    downloadOffers: () => dispatch(downloadOffers()),
  };
}

const withReducer = injectReducer({ key: 'catalogFilter', reducer });
const withSaga = injectSaga({ key: 'catalogFilter', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(HorizontalFilter);
